import { Directive, TemplateRef, ViewContainerRef, Input, inject } from '@angular/core';
import { IfFeatureService } from '../../services/if-feature/if-feature.service';

@Directive({
  selector: '[tdWbIfFeature]'
})
export class IfFeatureDirective {
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly ifFeatureService = inject(IfFeatureService);

  private hasView: boolean = false;

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  set tdWbIfFeature(key: string) {
    const featureFlag = this.ifFeatureService.getFeatureFlag<boolean>(key);
    const shouldShow = featureFlag ?? false;
    if (shouldShow && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!shouldShow && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
